export class AnnounceBar {
    constructor(barSelector = '#announce-bar', trackSelector = '#announce-track') {
        this.bar = document.querySelector(barSelector);
        this.track = document.querySelector(trackSelector);

        if (!this.bar || !this.track) return;

        this.isDragging = false;
        this.startX = 0;
        this.x = 0;
        this.animationFrame = null;

        this.init();
    }

    init() {
        this.duplicateContent();
        this.startAutoScroll();
        this.addDragEvents();
    }

    duplicateContent() {
        const original = this.track.innerHTML;
        const repeatCount = 3;

        let repeatedBefore = '';
        let repeatedAfter = '';

        for (let i = 0; i < repeatCount; i++) {
            repeatedBefore += original;
            repeatedAfter += original;
        }

        this.track.innerHTML = repeatedBefore + original + repeatedAfter;
        const totalWidth = this.track.scrollWidth;
        this.segmentWidth = totalWidth / (repeatCount * 2 + 1); // una sola sección
        this.x = -this.segmentWidth * repeatCount; // comenzamos centrados
        this.track.style.transform = `translateX(${this.x}px)`;
    }

    startAutoScroll() {
        const step = () => {
            if (!this.isDragging) {
                this.x -= 1;
                this.realignIfNeeded();
                this.track.style.transform = `translateX(${this.x}px)`;
            }
            this.animationFrame = requestAnimationFrame(step);
        };

        this.animationFrame = requestAnimationFrame(step);
    }

    realignIfNeeded() {
        const totalWidth = this.track.scrollWidth;
        const sectionWidth = this.segmentWidth;

        if (this.x <= -sectionWidth * 2) {
            this.x += sectionWidth;
        } else if (this.x >= -sectionWidth) {
            this.x -= sectionWidth;
        }
    }

    addDragEvents() {
        const updateTransform = () => {
            this.realignIfNeeded();
            this.track.style.transform = `translateX(${this.x}px)`;
        };

        this.bar.addEventListener('mousedown', (e) => {
            this.isDragging = true;
            this.startX = e.clientX;
            this.track.style.cursor = 'grabbing';
        });

        window.addEventListener('mousemove', (e) => {
            if (!this.isDragging) return;
            const delta = e.clientX - this.startX;
            this.startX = e.clientX;
            this.x += delta;
            updateTransform();
        });

        window.addEventListener('mouseup', () => {
            if (this.isDragging) {
                this.isDragging = false;
                this.track.style.cursor = 'grab';
            }
        });

        // Touch support
        this.bar.addEventListener('touchstart', (e) => {
            this.isDragging = true;
            this.startX = e.touches[0].clientX;
        });

        window.addEventListener('touchmove', (e) => {
            if (!this.isDragging) return;
            const delta = e.touches[0].clientX - this.startX;
            this.startX = e.touches[0].clientX;
            this.x += delta;
            updateTransform();
        });

        window.addEventListener('touchend', () => {
            this.isDragging = false;
        });
    }
}
